export const PBTCrmCasesActionType = {
  REQUEST_CRM_CASES: 'pbt/crm/REQUEST_CRM_CASES',
  RECEIVE_CRM_CASES: 'pbt/crm/RECEIVE_CRM_CASES',
  CRM_CASES_ERROR: 'pbt/crm/CRM_CASES_ERROR',
} as const;
